module.exports = __webpack_public_path__ + "ce5778cf594ea6d50ef4b3d10374a69e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/progressive_2023_chart.png
// module id = 1717
// module chunks = 0